import getProbabilityTag from "../../../utils/getProbabilityTag";
import getGroupActions from "./getGroupActions";

const getConfusionActions = (sampleGroup, probability) => {
  const probabilityTag = getProbabilityTag(probability);
  const actionArray = getGroupActions(sampleGroup);

  const result = actionArray?.map((groupAction) => {
    let type = "NEUTRAL";
    if (groupAction === "POSITIVE") {
      if (probabilityTag === "HIGH" || probabilityTag === "VERY_HIGH")
        type = "RECOMENDED";
      if (probabilityTag === "LOW" || probabilityTag === "VERY_LOW")
        type = "ALERT";
    } else if (groupAction === "NEGATIVE") {
      if (probabilityTag === "LOW" || probabilityTag === "VERY_LOW")
        type = "RECOMENDED";
      if (probabilityTag === "HIGH" || probabilityTag === "VERY_HIGH")
        type = "ALERT";
    } else if (groupAction === "UNASSIGNED") {
      if (
        (probabilityTag === "LOW" || probabilityTag === "VERY_LOW") &&
        sampleGroup === "NEGATIVE"
      )
        type = "ALERT";
      if (probabilityTag === "BELLOW_MEDIUM" && sampleGroup === "POSITIVE")
        type = "RECOMENDED";
      if (probabilityTag === "MEDIUM" && sampleGroup === "NEGATIVE")
        type = "RECOMENDED";
      if (
        (probabilityTag === "HIGH" || probabilityTag === "VERY_HIGH") &&
        sampleGroup === "POSITIVE"
      )
        type = "ALERT";
    }
    return {
      id: groupAction,
      type,
    };
  });

  return result;
};

export default getConfusionActions;

/*
export const probabilityThresholds = [
  { tag: VERY_LOW, threshold: 0 },
  { tag: LOW, threshold: 0.1 },
  { tag: BELLOW_MEDIUM, threshold: 0.25 },
  { tag: MEDIUM, threshold: 0.5 },
  { tag: HIGH, threshold: 0.75 },
  { tag: VERY_HIGH, threshold: 0.9 },
];
*/
